import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DataSourceUploadProgressService } from '../../../services/data-source-upload-progress.service';
import { ProcessingDataSource, DataSourceUploadProgress } from '../../../models/processing-data-source.model';
import { CancelDatasourceDialogComponent } from '../../dialogs/cancel-datasource-dialog/cancel-datasource-dialog.component';
import { DataSourceFacade } from '../../../facade/data-source.facade';
import { Subscription } from 'rxjs';
import { NbDialogService } from '@nebular/theme';

@Component({
  selector: 'morva-data-source-upload-progress-modal',
  templateUrl: './data-source-upload-progress-modal.component.html',
  styleUrls: ['./data-source-upload-progress-modal.component.scss'],
})
export class DataSourceUploadProgressModalComponent implements OnInit, OnDestroy {
  isOpen: boolean = false;
  items: DataSourceUploadProgress[] = [];
  isBlueBoxOpen: boolean = false;
  isRedBoxOpen: boolean = false;
  subscriptions: Subscription[] = [];
  
  constructor(
    private router: Router,
    private progressService: DataSourceUploadProgressService, 
    private dataSourceFacade: DataSourceFacade,
    private dialogService: NbDialogService
  ) {}

  ngOnInit(): void {
    this.setSubscribers();
    this.items = this.items.filter((item) => item.completionPercentage !== 100)
    if(!this.items.length) this.closeModal()
  }

  setSubscribers(): void {
    this.subscriptions.push(
      this.progressService.getModalState().subscribe(
        (isOpen) => { this.isOpen = isOpen; }
      )
    )

    this.subscriptions.push(
      this.dataSourceFacade.getDataSourceUploadProgress().subscribe(
        (items) => { 
          this.items = items; 
          if(!this.items.length) this.closeModal()
        }
      )
    )

    this.subscriptions.push(
      this.dataSourceFacade.getDataSourceUploadCanceledValue().subscribe(
        (value: string | null) => {
          if(value) this.removeCanceledItem(value)  
        }
      )
    )
  }

  removeCanceledItem(id: string) {
    this.items = this.items.filter((item) => item.dataSourceId !== id)
    this.dataSourceFacade.updateDataSourceUploadCanceledValue(null)
    if(!this.items.length) this.closeModal()
  }

  cancelUploadProgress(item: any) {
    const dialogRef = this.dialogService.open(CancelDatasourceDialogComponent,{ context: { item: item } });
    dialogRef.onClose.subscribe((result) => {
      if (result) {
        const URL = this.router.url
        this.dataSourceFacade.cancelDataSourceUploadProgress(item.workspaceId, item.dataSourceId, URL)
      }
    });
  }

  onRetryDataSource(dataSource: ProcessingDataSource): void {
    this.dataSourceFacade.retryProcessing(dataSource);
  }

  toggleData() {
    this.isBlueBoxOpen = !this.isBlueBoxOpen;
  }

  toggleRedError(index: number): void{
    //this.items[index].isRedBoxExpanded = !this.items[index].isRedBoxExpanded;
  }

  toggleItem(index: number): void {
    this.items[index].isExpanded = !this.items[index].isExpanded;
  }

  closeItem(index: number): void {
    this.items.splice(index, 1)
    if(!this.items.length) this.closeModal()
  }

  closeModal() {
    this.progressService.closeModal();
  }

  ngOnDestroy(): void {
    this.progressService.stop();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}

